import { commonArrowBtn } from '../../../common/common-use-arrow-btn';
import { commonInArticleConfig } from '../common-in-article.config';

export const formatConfigUnmarshaller = {
  ...commonInArticleConfig,
  ...commonArrowBtn
};
